// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_iw-0";